module.exports = __webpack_public_path__ + "img/receive-square-2.674b3184.svg";